const isImageFileUrl = (url?: string) => !!url && /\.(jpe?g|png)$/i.test(url);

export default isImageFileUrl;
